App.namespace('es6.shared.ab_tests_helper', () => {

  /**
   * @see https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
   */
  function murmurhash2_32_gc(str, seed) {
    var
      l = str.length,
      h = seed ^ l,
      i = 0,
      k;

    while (l >= 4) {
      k =
        ((str.charCodeAt(i) & 0xff)) |
        ((str.charCodeAt(++i) & 0xff) << 8) |
        ((str.charCodeAt(++i) & 0xff) << 16) |
        ((str.charCodeAt(++i) & 0xff) << 24);

      k = (((k & 0xffff) * 0x5bd1e995) + ((((k >>> 16) * 0x5bd1e995) & 0xffff) << 16));
      k ^= k >>> 24;
      k = (((k & 0xffff) * 0x5bd1e995) + ((((k >>> 16) * 0x5bd1e995) & 0xffff) << 16));

      h = (((h & 0xffff) * 0x5bd1e995) + ((((h >>> 16) * 0x5bd1e995) & 0xffff) << 16)) ^ k;

      l -= 4;
      ++i;
    }

    switch (l) {
      case 3: h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
      case 2: h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
      case 1: h ^= (str.charCodeAt(i) & 0xff);
        h = (((h & 0xffff) * 0x5bd1e995) + ((((h >>> 16) * 0x5bd1e995) & 0xffff) << 16));
    }

    h ^= h >>> 13;
    h = (((h & 0xffff) * 0x5bd1e995) + ((((h >>> 16) * 0x5bd1e995) & 0xffff) << 16));
    h ^= h >>> 15;

    return h >>> 0;
  }

  function hashABVersion(experimentKey, userKey, variations = 2) {
    return murmurhash2_32_gc(experimentKey + '|' + userKey, 0) % variations;
  }

  /**
   * @param {string} userKey
   * @param {string} experimentKey
   * @param {number} variations
   * @returns {Number|null}
   */
  function getVersionFromKey(userKey, experimentKey, variations = 2) {
    if (16 % variations !== 0) {
      console.warn(`AB test variations should be a factor of 16 to ensure equal distribution, still will work.`);
    }

    if (!userKey || !experimentKey) {
      throw new Error('Missing userKey or experimentKey for AB test');
    }

    // never start experiment for e2e tests, and not count in A version
    if (navigator.userAgent.includes('TGV_E2E_PLAYWRIGHT_TEST')) {
      return null;
    }

    try {
      return hashABVersion(experimentKey, userKey, variations);
    } catch (err) {
      console.error(`Could not allocate ab test version`, err);
    }

    return null;
  }

  /**
   * @param {string} experimentKey
   * @param {number} variations
   * @returns {Number|null}
   */
  function getVersionFromCookieId(experimentKey, variations = 2) {
    if (!experimentKey) {
      throw new Error('Missing experimentKey for AB test');
    }

    try {
      const overwriteCookie = document.cookie
        .split("; ")
        .find((row) => row.startsWith("tgv_experiments_overwrite="))
        ?.split("=")[1];

      if (overwriteCookie) {
        const versions = JSON.parse(decodeURIComponent(overwriteCookie));
        if (typeof versions[experimentKey] !== 'undefined') {
          return versions[experimentKey];
        }
      }
    } catch (err) {}

    const abSeed = document.cookie.match(/ab-test-seed=([a-z0-9-]+)/)?.[1];

    if (!abSeed) {
      return null;
    }

    return getVersionFromKey(abSeed, experimentKey, variations);
  }

  return {
    getVersionFromKey,
    getVersionFromCookieId,
  }
});
